import styled, { css } from 'styled-components';
import { sizeMapper, alignMapper } from '../../../utils/styles';
import { loadingOverlay } from '../../styles';

const Container = styled.div`
  position: relative;
  width: 100%;
  margin: ${props => sizeMapper(props.margin, 'no')};
  padding: ${props => sizeMapper(props.padding, 'no')};

  ${props =>
    props.isLoading &&
    css`
      ${loadingOverlay('24px')};
    `};

  ${props =>
    props.align &&
    css`
      display: flex;
      justify-content: ${alignMapper(props)};
    `}
`;

export default Container;
